import { useGoogleLogin } from '@react-oauth/google'


const GoogleDrive = () => {

    // const Login = useGoogleLogin(
    //     {
    //         scope: 'https://www.googleapis.com/auth/drive.file',
    //         flow: 'auth-code',
    //         onSuccess: async (response) => {
    //             const { code } = response
    //             console.log('Código recibido:', code)

    //             // Enviar este código al backend
    //             // await fetch('https://tuapi.com/api/auth/google', {
    //             //     method: 'POST',
    //             //     headers: { 'Content-Type': 'application/json' },
    //             //     body: JSON.stringify({ code })
    //             // })

    //             await fetch('http://localhost:3000/api/googleAuth/startExam', {
    //                 method: 'POST',
    //                 headers: {
    //                     'Content-Type': 'application/json'
    //                 },
    //                 body: JSON.stringify({
    //                     accessToken: code,
    //                     folderName: 'Escenario_1',
    //                     fileName: 'Escenario1.xlsx',
    //                     filePath: '/var/escenarios/Escenario1.xlsx'
    //                 })
    //             })
    //         },
    //             onError: (error) => {
    //             console.error('Error al iniciar sesión con Google:', error)
    //         }
    //     }
    // )

    const GetUserToken = async () => {
        try {
            const tmpUserData = sessionStorage.getItem("userData")

            if (!tmpUserData) {
                return
            }

            const userData = JSON.parse(tmpUserData)

            const token = userData?.token
            if (!token) {
                return
            }

            return token
        } catch (error) {
            
        }
    }

    const Login = useGoogleLogin({
        flow: 'auth-code',
        scope: 'https://www.googleapis.com/auth/drive.file',
        onSuccess: async (response) => {
            //const code = response.code
            console.log("code:", response.code);

            
            // Este es el token de la plataforma (ya lo tienes en tu sistema)
            const token = await GetUserToken()
            if (!token) {
                return
            }
            // const dataToSend = {
            //     code: code,
            //     token: token
            // }
            const res = await fetch("http://localhost:5194/api/googleAuth/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    code: response.code,
                    token: token
                })
            })
            //console.log("Google Drive vinculado correctamente")
            const data = await res.json()
            console.log("Resultado:", data)
            //sessionStorage.setItem("folderId", data.folderId)
        }
    })
    
    const StartExam = async () => {
        try {
            // Este es el token de la plataforma (ya lo tienes en tu sistema)
            const token = await GetUserToken()
            if (!token) {
                return
            }
            debugger
            const res = await fetch("http://localhost:5194/api/googleAuth/startExam", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    token: token//,
                    //folderId: currentFolderId
                })
            })
            debugger
            const result = await res.json()
            debugger
            if (res.ok) {
                console.log("Examen iniciado:", result)
                // Puedes mostrar mensaje o actualizar instrucciones
            } else {
                console.log("Error: " + result.error)
            }
        } catch (error) {
            
        }
    }

    const SkipQuestion = async () => {
        try {
            // Este es el token de la plataforma (ya lo tienes en tu sistema)
            const token = await GetUserToken()
            if (!token) {
                return
            }
            debugger
            const res = await fetch("http://localhost:5194/api/googleAuth/skipQuestion", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    token: token//,
                    //folderId: currentFolderId
                })
            })
            debugger
            const result = await res.json()
            debugger
            if (res.ok) {
                console.log("Pregunta saltada:", result)
                // Puedes mostrar mensaje o actualizar instrucciones
            } else {
                console.log("Error: " + result.error)
            }
        } catch (error) {
            
        }
    }

    const RestartQuestion = async () => {
        try {
            // Este es el token de la plataforma (ya lo tienes en tu sistema)
            const token = await GetUserToken()
            if (!token) {
                return
            }
            debugger
            const res = await fetch("http://localhost:5194/api/googleAuth/restartQuestion", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    token: token//,
                    //folderId: currentFolderId
                })
            })
            debugger
            const result = await res.json()
            debugger
            if (res.ok) {
                console.log("Pregunta reiniciada:", result)
            } else {
                console.log("Error: " + result.error)
            }
        } catch (error) {
            
        }
    }

    // const CheckGoogleConnected = async () => {
    //     try {
    //         // Este es el token de la plataforma (ya lo tienes en tu sistema)
    //         const token = await GetUserToken()
    //         if (!token) {
    //             return
    //         }
    //         debugger
    //         const res = await fetch(`http://localhost:5194/api/auth/status/${token}`)
    //         const data = await res.json()
    //         debugger
    //         if (data.connected) {
    //             console.log("Cuenta de Google ya vinculada")
    //         } else {
    //             console.log("Google no está conectado")
    //         }
    //     } catch (error) {
            
    //     }
    // }


    return (
        <>
            <div className='container'>
                <p>Exam - Google Drive</p>

                <button type="button" className='Btn__Ztudia--PrimaryOutline' onClick={() => Login()}>Iniciar sesión con Google</button>
                <button type="button" className='Btn__Ztudia--PrimaryOutline' onClick={StartExam}>Iniciar examen</button>
                <button type="button" className='Btn__Ztudia--PrimaryOutline' onClick={RestartQuestion}>Reiniciar pregunta</button>
                <button type="button" className='Btn__Ztudia--PrimaryOutline' onClick={SkipQuestion}>Saltar pregunta</button>

                {/* <button type="button" className='Btn__Ztudia--PrimaryOutline' onClick={SkipQuestion}></button>     */}
            </div>
        </>
    )
}

export { GoogleDrive };


// {
//     "id": 1,
//     "name": "Diagnóstico",
//     "remainingTime": 300,
//     "questions": {
//         "remaining": 5,
//         "currentQuestion": {
//             "id": 2,
//             "filePath": "X/libro1.xlsx"
//         }
//     }
// }